/** New room on a phone and an iPad: a sheet that asks "What are you making?" and opens the first step of either way. */
import { BOARD_NEW_PATH } from "../../board/paths";
import { GroupedList, ListRow } from "../../components/season/GroupedList";
import { Picture } from "../../components/season/Picture";
import { Sheet } from "../../components/ui/Sheet";
import { SAMPLE_ART } from "../../lib/sample-art";

export function NewRoomSheet({ onClose }: { onClose: () => void }) {
  return (
    <Sheet open onClose={onClose} title="What are you making?">
      <GroupedList className="rm-new">
        <ListRow
          lead={<Picture size="sm" src={SAMPLE_ART.talk} />}
          title="A recording"
          sub="A talk you have already recorded."
          to={`${BOARD_NEW_PATH}?from=recording`}
        />
        <ListRow
          lead={<Picture size="sm" src={SAMPLE_ART.live} />}
          title="A live room"
          sub="Live on a date, once or every week."
          to={`${BOARD_NEW_PATH}?from=live`}
        />
      </GroupedList>
    </Sheet>
  );
}
